import { User } from '@/features/auth/types/user';
import { supabase } from '@/lib/supabase';

export const getUser = async (): Promise<User | null> => {
  const { data, error } = await supabase.auth.getUser();
  if (error) {
    throw error;
  }
  return data.user;
};
